import * as actions from '../../Action/SuperAdmin/FetchTenant'

export const initialState = {
    tenantData: null,
    tenantDataFail:null,
    loaderStatus:false,
    tenantSearchKey:null   
}

export default function reducer(state = initialState, action){
    
    switch(action.type){
        case actions.TENANATDATA : return tenantData(state,action);
        case actions.TENANRDATAFAIL : return tenantDataFail(state,action)
        case actions.LOGGEDINLOADER: return loggedInLoader(state,action)
        case actions.TENANATSAERCHKEY: return tenantSearchKey(state,action)

    default: return state
    }
}

const tenantData = (state,action) => {
    return {
        ...state,
        tenantData: action.payload
    }
}

const loggedInLoader =(state,action) => {
    return{
        ...state,
        loaderStatus: action.payload
    }
}

const tenantDataFail =(state,action)=>{
    return {
        ...state,
        tenantDataFail: action.payload
    }
}


const tenantSearchKey = (state,action) => {
    return {
        ...state,
        tenantSearchKey: action.payload
    }
}